import ability from '@/libs/acl/ability';
import store from '@/store';
import { Actions } from '~/libs/acl/actions';
import { Roles } from '~/libs/acl/roles';
import { Subjects } from '~/libs/acl/subjects';

/**
 * DataVolley administrators (users.data_volley_admin, /auth/me isDataVolleyAdmin) additionally
 * get the DataVolleyAdmin subject: the DataVolley API settings (route and menu entry). The flag is
 * per user, not per role, so it is added on top of the role abilities after login and on start-up.
 */
export async function applyDataVolleyAdminAbility() {
    if (store.getters['user/getRole'] !== Roles.Administrator) return;
    if (ability.can(Actions.manage, Subjects.DataVolleyAdmin)) return;
    if (!(await store.getters['user/isDataVolleyAdmin'])) return;

    ability.update([...ability.rules, { action: Actions.manage, subject: Subjects.DataVolleyAdmin }]);
}
